import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchExchangeById } from './controller/exchange-controller';
import { Spinner } from '../../../components/Spinner';
import { toast } from 'react-toastify';
import EditExchangeForm from './components/EditExchangeForm';

const EditExchange = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [exchange, setExchange] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const dataFetchedRef = useRef(false);

  useEffect(() => {
    // Prevent duplicate fetches
    if (dataFetchedRef.current) return;
    
    const loadExchange = async () => {
      try {
        setIsLoading(true);
        setError(null);
        
        console.log('Fetching exchange with ID:', id);
        const data = await fetchExchangeById(id);
        
        console.log('Exchange data received:', data);
        setExchange(data);
        dataFetchedRef.current = true;
      } catch (err) {
        console.error('Error loading exchange:', err);
        setError(err.message || 'Impossible de charger les données de l\'échange');
        toast.error('Impossible de charger les données de l\'échange');
      } finally {
        setIsLoading(false);
      }
    };

    if (id) {
      loadExchange();
    } else {
      setError('ID de l\'échange non spécifié');
      setIsLoading(false);
    }
  }, [id]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="py-6 px-4 sm:px-6 lg:px-8">
        <div className="bg-red-50 border border-red-200 rounded-md p-4 my-6">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-red-800">Erreur de chargement</h3>
              <div className="mt-2 text-sm text-red-700">
                <p>{error}</p>
              </div>
              <div className="mt-4">
                <button
                  type="button"
                  onClick={() => navigate('/admin/exchanges')}
                  className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                >
                  Retour à la liste
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!exchange) {
    return (
      <div className="py-6 px-4 sm:px-6 lg:px-8">
        <div className="text-center py-10">
          <h3 className="text-lg font-medium text-gray-900">Échange non trouvé</h3>
          <div className="mt-2 text-sm text-gray-500">
            <p>L'échange avec l'ID {id} n'existe pas ou a été supprimé.</p>
          </div>
          <div className="mt-6">
            <button
              type="button"
              onClick={() => navigate('/admin/exchanges')}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[#174540] hover:bg-[#0d2926] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#174540]"
            >
              Retour à la liste
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="py-6 px-4 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-semibold text-gray-900 mb-6">Modifier l'échange</h1>
      <EditExchangeForm exchangeData={exchange} />
    </div>
  );
};

export default EditExchange;